/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-cycle */
/* eslint-disable no-alert */
/* eslint-disable react/jsx-indent */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState, useCallback, useRef } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import GoogleMapReact from 'google-map-react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useDropzone } from 'react-dropzone';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { KanbanComponent, ColumnsDirective, ColumnDirective } from '@syncfusion/ej2-react-kanban';
import { ButtonComponent, SwitchComponent } from '@syncfusion/ej2-react-buttons';
import { AccordionComponent } from '@syncfusion/ej2-react-navigations';
import { DatePickerComponent, TimePickerComponent } from '@syncfusion/ej2-react-calendars';
import { DialogUtility, DialogComponent } from '@syncfusion/ej2-react-popups';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { TextBoxComponent, UploaderComponent } from '@syncfusion/ej2-react-inputs';
import { Internationalization } from '@syncfusion/ej2-base';
import { Header, KMLMapContainer, MyDropZone } from '.';
import { useStateContext } from '../contexts/ContextProvider';

import '../pages/inventory.css';
import '../pages/Zackat.css';

// 1. Initialize the internationalization library
const intl = new Internationalization();
const customDateFormat = 'MM/dd/yyyy';
// 2. Custom validation function
function validateCustomDate(args) {
  if (!args.value) return false;

  // Parse string based on defined format
  const parsedDate = intl.parseDate(args.value, { format: customDateFormat, type: 'date' });

  // Check if valid date object
  return parsedDate instanceof Date && !isNaN(parsedDate.getTime());
}
const customTimeValidation = (args) => {
  // Regex matching "hh:mm am/pm" (e.g., 12:30 PM, 04:15 am)
  const timeRegex = /^(0?[1-9]|1[0-2]):[0-5][0-9] [a|p]m$/i;
  return timeRegex.test(args.value);
};

export const Jobs = () => {
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    return <p>Please login... </p>;
  }
  const statusOptions = [
    { value: 'active', text: 'Active' },
    { value: 'inactive', text: 'InActive' },
    { value: 'completed', text: 'Completed' },
    { value: 'unscheduled', text: 'Unscheduled' },
  ];
  const statusFieldSettings = { text: 'text', value: 'value' };
  const itemTemplate = (props) => {
    // Logic to determine color based on data (e.g., data.colorField)
    const itemStyle = {
      backgroundColor: props.color || 'white', // Use a color from your data source
      padding: '10px, 10px',
    };
    return (
      <div style={itemStyle}>
        {props.text}
      </div>
    );
  };
  const {
    boss,
    isMobile,
  } = useStateContext();

  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const { REACT_APP_API_ENDPOINT } = process.env;
  let { REACT_APP_GOOGLE_MAPS_API_KEY } = process.env;
  const { REACT_APP_GOOGLE_MAPS_API_KEY_DEV } = process.env;
  const { REACT_APP_ENV } = process.env;
  const { REACT_APP_GOOGLE_MAPS_ID } = process.env;
  const [searchParams] = useSearchParams();
  let orgId = searchParams.get('id');
  let name = `${searchParams.get('name')}`;
  const [kmlData, setKmlData] = useState([]);
  const [mgrData, setMgrData] = useState([]);
  const [crudImport, setCrudImport] = useState(true);

  // const [mapDisplay, setMapDisplay] = useState(true);
  const [polyup, setPolyUp] = useState(false);
  const [kmapProps, setKMapProps] = useState({});
  const [kmapDialog, setKMapDialog] = useState(false);
  const handleGMapDialogClick = () => {
    setKMapDialog(!kmapDialog);
  };
  let uploadObj;
  function onFileUpload(args) {
    // add addition data as key-value pair.
    if (!name || !orgId || orgId.length === 0 || name.length === 0) {
      return;
    }
    if (!confirm(`Upload to ${name}`)) {
      args.cancel = true;
      return;
    }
    args.customFormData = [{ organizationid: orgId }];
  }

  const jobpath = {
    removeUrl: `${REACT_APP_API_ENDPOINT}/jobsremove`,
    saveUrl: `${REACT_APP_API_ENDPOINT}/jobsupload`,
  };
  function completeUpload(args) {
    DialogUtility.alert(`Upload success ${args.fileData[0].status}`);
    setPolyUp(!polyup);
  }
  const buttons = { browse: 'Choose File', clear: 'Clear All', upload: 'Upload All' };
  const kmlmapbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        setKMapDialog(!kmapDialog);
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];

  if (!REACT_APP_ENV || REACT_APP_ENV === '') {
    REACT_APP_GOOGLE_MAPS_API_KEY = REACT_APP_GOOGLE_MAPS_API_KEY_DEV;
  }
  let dialogInstance;
  function dialogClick(f, hdr, content, e) {
    const ok = null;
    dialogInstance = DialogUtility.confirm({
      title: hdr,
      content,
      okButton: ok,
      cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
      showCloseIcon: true,
      closeOnEscape: true,
      isModal: true,
      animationSettings: { effect: 'Zoom' },
    });
  }
  async function renderMarkers(map, maps, point, pointname) {
    const newCenter = { lng: Number(point[0]), lat: Number(point[1]) };
    // const mypin = 'http://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png';
    const { AdvancedMarkerElement } = await window.google.maps.importLibrary('marker');
    const customIcon = document.createElement('img');
    // customIcon.src = `${zackatPin}`;
    customIcon.src = 'https://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png';
    customIcon.style.width = '50px';
    customIcon.style.height = '50px';
    const marker = new AdvancedMarkerElement({
      position: newCenter,
      map,
      content: customIcon,
      title: pointname,
    });
    /*
    const marker = new maps.Marker({
      position: newCenter,
      map,
      icon: {
        // path: maps.SymbolPath.CIRCLE,
        url: zackatPin,
        scaledSize: new maps.Size(35, 35),
        scale: 10,
      },
      title: pointname,
    });
    */
    map.setCenter(newCenter);
    return marker;
  }

  const kanbanObj = useRef(null);
  let mapObj;
  const jobsname = `Jobs: ${name}`;
  if (!orgId || orgId === 'null') {
    if (selectedOrg) {
      orgId = selectedOrg.id;
      name = `${selectedOrg.name}`;
    } else if (usr && usr.organizationid) {
      orgId = usr.organizationid;
      name = '';
    }
  }
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [jobs, setJobs] = useState(false);

  const onDrop = useCallback((acceptedFiles, zoneId) => {
    // Do something with the files
    if (!confirm('Upload this KML file?')) {
      return;
    }
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();
      const filedata = new FormData();
      reader.onabort = () => dialogClick('na', 'On Drop', 'file reading was aborted', null);
      reader.onerror = () => dialogClick('na', 'On Drop', 'file reading has failed', null);
      reader.onload = () => {
        // Do whatever you want with the file contents
        filedata.append('userfile', file);
        filedata.append('fileName', file.name);
        filedata.append('organizationid', orgId);
        filedata.append('organization', name);
        filedata.append('jobid', zoneId);
        fetch(`${REACT_APP_API_ENDPOINT}/kmlfileup`, {
          method: 'POST',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
          },
          body: filedata,
        })
          .then((response) => response.json())
          .then((responseJson) => {
            setPolyUp(!polyup);
            dialogClick('na', 'KML File Upload', `Success:  ${file.name}`, null);
            /*
            setTimeout(
              setPolyUp(!polyup),
              1000,
            );
            */
            // window.location.reload();
          })
          .catch(() => {
            dialogClick('na', 'KML File Upload', `An error has occured during upload of KML file ${file.name} !`, null);
          });
      };
      reader.readAsArrayBuffer(file);
    }, []);
  });

  // Define multiple dropzones using the same logic but unique IDs
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (files) => onDrop(files, 'ZoneA'),
    accept: {
      'application/vnd.google-earth.kml': ['.kml'],
      'application/vnd.google-earth.kmz': ['.kmz'],
    },
  });
  // 1. Define the Dialog Template
  const dialogCardTemplate = (props) => (
      <div className="dialog-wrapper">
          <div className="form-group">
            <label>Title</label>
            <TextBoxComponent
              id="title"
              name="title"
              className="e-field e-input"
              value={props.title}
              placeholder="Title"
            />
          </div>
          <div className="form-group">
          <DropDownListComponent
            id="status"
            width="100%"
            cssClass="e-outline"
            name="status"
            className="e-field e-input"
            dataSource={statusOptions}
            fields={statusFieldSettings}
            itemTemplate={itemTemplate}
            floatLabelType=""
            placeholder="Status"
            value={props.status}
          />
          </div>
          <div className="form-group">
            <TextBoxComponent
              id="Description"
              name="description"
              className="e-field e-input"
              value={props.description}
              placeholder="Description"
            />
          </div>
          <div className="form-group">
            <DatePickerComponent
              id="date"
              name="date"
              className="e-field e-input"
              value={props.date}
              format="MM/dd/yyyy"
              placeholder="Start Date"
            />
          </div>
          <div className="form-group">
            <TimePickerComponent
              id="time"
              name="time"
              className="e-field e-input"
              value={props.time}
              format="h:mm a"
              placeholder="Start Time"
            />
          </div>
          <div className="form-group">
              <DatePickerComponent
                id="enddate"
                name="enddate"
                className="e-field e-input"
                format="MM/dd/yyyy"
                value={props.enddate}
                placeholder="End Date"
              />
          </div>
          <div className="form-group">
            <TimePickerComponent
              id="endtime"
              name="endtime"
              className="e-field e-input"
              value={props.endtime}
              format="h:mm a"
              placeholder="End Time"
            />
          </div>
          <div className="form-group">
            <TextBoxComponent
              id="locationName"
              name="locationName"
              className="e-field e-input"
              value={props.locationName}
              placeholder="KML Name"
            />
          </div>
          <div className="form-group">
            <TextBoxComponent
              id="radius"
              name="radius"
              className="e-field e-input"
              value={props.radius}
              placeholder="Radius in meters from center point"
            />
          </div>
      </div>
  );
  const dateValidationRules = {
    required: [true, 'Date is required'],
    custom: [validateCustomDate, 'Please enter a date in the format: 05/01/2026'],
  };
  const timeValidationRules = {
    required: [true, 'Time is required'],
    custom: [customTimeValidation, 'Please enter a time in the format: 05:30 AM'],
  };
  const fields = [
    { text: 'Title', key: 'title', type: 'TextBox', validationRules: { required: true } },
    { text: 'Status', key: 'status', type: 'DropDown', validationRules: { required: true } },
    { text: 'Description', key: 'description', type: 'TextBox' },
    { text: 'Start Date', key: 'date', type: 'TextBox', validationRules: dateValidationRules },
    { text: 'Start Time', key: 'time', type: 'TextBox', validationRules: timeValidationRules },
    { text: 'End Date', key: 'enddate', type: 'TextBox', validationRules: dateValidationRules },
    { text: 'End Time', key: 'endtime', type: 'TextBox', validationRules: timeValidationRules },
    { text: 'KML [Re]Name:', key: 'locationName', type: 'TextBox' },
    { text: 'Radius<br />(in meters)', key: 'radius', placeHolder: 'Radius in meters from center point', type: 'TextBox' },
  ];

  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = orgId;
      usr.organization = name;
    }
    // fetch data
    const dataFetch = async () => {
      try {
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        const url = `${REACT_APP_API_ENDPOINT}/jobs?${query}`;
        const mydata = await (
          await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })
        ).json();
        const mylocs = [];
        if (mydata.locations) {
          mydata.locations.forEach((kml) => {
            if (kml.document.name.includes('~') && kml.document.folder && kml.document.folder.name && !kml.document.folder.name.includes('~')) {
              mylocs.push({ value: kml._id, text: kml.document.folder.name });
            } else {
              mylocs.push({ value: kml._id, text: kml.document.name });
            }
          });
        }
        const mymgrs = [];
        if (mydata.managers) {
          mydata.managers.forEach((mgr) => {
            mymgrs.push({ value: mgr._id, text: `${mgr.first} ${mgr.last}` });
          });
        }
        mydata.jobs.forEach((element, index) => {
          if (element.location && element.location.name) {
            mydata.jobs[index].locationName = element.location.name;
          } else {
            mydata.jobs[index].locationName = 'unassigned';
          }
          if (element.date && element.date.length > 0) {
            const date = new Date(element.date);
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            const yyyy = date.getFullYear();
            mydata.jobs[index].date = `${mm}/${dd}/${yyyy}`; // Result: "05/20/2026"
          }
          if (element.enddate && element.enddate.length > 0) {
            const date = new Date(element.enddate);
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            const yyyy = date.getFullYear();
            mydata.jobs[index].enddate = `${mm}/${dd}/${yyyy}`; // Result: "05/20/2026"
          }
        });
        setKmlData(mylocs);
        setMgrData(mymgrs);
        setData(mydata);
        setJobs(true);
        setLoading(false);
      } catch (err) {
        setData([]);
        setLoading(false);
      }
    };
    // set state when the data received
    dataFetch();
  }, [polyup]); // mapDisplay

  const actionComplete = (args) => {
    /** Set initial Focus */
    if (args.requestType === 'cardCreated') {
      if (args.addedRecords && confirm(`Add this entry: ${args.addedRecords[0].title} for Organization ${name}?`)) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        const editedData = args.addedRecords;
        if (editedData.length > 0) {
          editedData[0].organizationid = orgId;
          editedData[0].organization = name;
          if (args.addedRecords[0].locationName && args.addedRecords[0].locationName.length > 0) {
            editedData[0].location = { _id: '', name: args.addedRecords[0].locationName };
          } else {
            editedData[0].location = { _id: '', name: '' };
          }
        } else {
          editedData.organizationid = orgId;
          editedData.organization = name;
          if (args.addedRecords[0].locationName && args.addedRecords[0].locationName.length > 0) {
            editedData[0].location = { _id: '', name: args.addedRecords[0].locationName };
          } else {
            editedData[0].location = { _id: '', name: '' };
          }
        }
        fetch(`${REACT_APP_API_ENDPOINT}/jobs`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              dialogClick('na', 'Job Insert', responseJson.response, null);
            } else {
              dialogClick('na', 'Job Insert', responseJson.response, null);
            }
          })
          .catch(() => {
            dialogClick('na', 'Job Insert', 'error add job', null);
          });
      } else {
        args.cancel = true;
      }
    } else if (args.requestType === 'cardChanged') {
      if (args) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        const editedData = args.changedRecords;
        if (editedData.length > 0) {
          editedData[0].organizationid = orgId;
          editedData[0].organizationname = name;
        } else {
          editedData.organizationid = orgId;
          editedData.organization = name;
        }
        if (args.changedRecords[0].locationName && args.changedRecords[0].locationName.length > 0) {
          editedData[0].location.name = args.changedRecords[0].locationName;
        }
        fetch(`${REACT_APP_API_ENDPOINT}/jobs`, {
          method: 'UPDATE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              dialogClick('na', 'Job Update', responseJson.response, null);
            } else {
              dialogClick('na', 'Job Update', responseJson.response, null);
            }
          })
          .catch(() => {
            dialogClick('na', 'Job Update', 'error updating job', null);
          });
      }
    } else if (args.requestType === 'cardRemoved') {
      const editedData = args.deletedRecords;
      if (editedData) {
        // The default edit operation is cancelled
        // Here you can send the updated data to your server using AJAX call
        if (editedData.length > 0) {
          editedData[0].organizationid = orgId;
          editedData[0].organizationid = name;
        } else {
          editedData.organizationid = orgId;
          editedData.organizationid = name;
        }
        fetch(`${REACT_APP_API_ENDPOINT}/jobs`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData),
        })
          .then((response) => response.json())
          .then((responseJson) => {
            // The added/edited data will be saved in the Grid
            if (responseJson && responseJson.response && responseJson.response !== 'OK') {
              dialogClick('na', 'Job Delete', responseJson.response, null);
            } else {
              dialogClick('na', 'Job Delete', responseJson.response, null);
            }
          })
          .catch(() => {
            dialogClick('na', 'Job Delete', 'error deleting job', null);
          });
      }
    }
  };
  function locationUpdated(e) {
    let found = -1;
    const kid = e.target.id.replace('KML_', '');
    for (let i = 0; i < data.jobs.length; i += 1) {
      if (kid === data.jobs[i].Id) {
        found = i;
        break;
      }
    }
    if (found !== -1 && kanbanObj && data.jobs[found]) {
      if (e.target.itemData.value !== data.jobs[found].location.Id) {
        if (confirm(`Update Job ${data.jobs[found].title} to Location to ${e.value}`)) {
          // eslint-disable-next-line prefer-object-spread
          const carddata = {
            Id: data.jobs[found].Id,
            date: data.jobs[found].date,
            enddate: data.jobs[found].enddate,
            description: data.jobs[found].description,
            location: {
              Id: e.target.itemData.value,
              name: e.target.itemData.text,
            },
            manager: data.jobs[found].manager,
            organization: data.jobs[found].organization,
            organizationid: data.jobs[found].organizationid,
            status: data.jobs[found].status,
            time: data.jobs[found].time,
            endtime: data.jobs[found].endtime,
            timestamp: data.jobs[found].timestamp,
            title: data.jobs[found].title,
          };
          const cards = {};
          cards.requestType = 'cardChanged';
          const ary = [];
          ary.push(carddata);
          cards.changedRecords = ary;
          actionComplete(cards);
          data.jobs[found].location = carddata.location;
          /*
          setTimeout(
            () => {
              setPolyUp(!polyup);
              window.location.reload();
            },
            1000,
          );
          */
        }
      }
    }
  }

  function renderMap(map, maps, props) {
    // Define the LatLng coordinates for the polygon's path.
    const coords = [];
    let path = false;
    if (data.locations) {
      data.locations.forEach((element) => {
        if (props.location.Id === element._id) {
          // || (element.document.folder && element.document.folder.name && element.document.folder.name === props.location.name)) {
          if (element.document && element.document.placemark && element.document.placemark.length > 0) {
            element.document.placemark.forEach((place) => {
              if (place.polygon && place.polygon.outerBoundaryIs && place.polygon.outerBoundaryIs.linearRing && place.polygon.outerBoundaryIs.linearRing.poly) {
                place.polygon.outerBoundaryIs.linearRing.poly.forEach((coord) => {
                  const c = { lat: Number(coord.lat), lng: Number(coord.lng) };
                  coords.push(c);
                });
              }
              if (place.polygon && place.polygon.outerBoundaryIs && place.polygon.outerBoundaryIs.linearRing && place.polygon.outerBoundaryIs.linearRing.path) {
                place.polygon.outerBoundaryIs.linearRing.path.forEach((coord) => {
                  const c = { lat: Number(coord.lat), lng: Number(coord.lng) };
                  path = true;
                  coords.push(c);
                });
              }
            });
            if (coords.length > 0) {
              setTimeout(() => {
                const cntr = parseInt(coords.length / 2, 10);
                const newCenter = coords[cntr];
                map.setCenter(newCenter);
                map.setZoom(16);
              }, 100);
            }
            if (!path && coords.length > 0) {
              const point = [coords[0].lat, coords[0].lng, '0'];
              renderMarkers(map, maps, point, element.document.placemark[0].name);
            }
          } else if (element.document && element.document.folder && element.document.folder.placemark && element.document.folder.placemark.length > 0) {
          // Try Folder
            element.document.folder.placemark.forEach((place) => {
              if (place.polygon && place.polygon.outerBoundaryIs && place.polygon.outerBoundaryIs.linearRing && place.polygon.outerBoundaryIs.linearRing.poly) {
                place.polygon.outerBoundaryIs.linearRing.poly.forEach((coord) => {
                  const c = { lat: Number(coord.lat), lng: Number(coord.lng) };
                  path = false;
                  coords.push(c);
                });
              }
              if (place.polygon && place.polygon.outerBoundaryIs && place.polygon.outerBoundaryIs.linearRing && place.polygon.outerBoundaryIs.linearRing.path) {
                place.polygon.outerBoundaryIs.linearRing.path.forEach((coord) => {
                  const c = { lat: Number(coord.lat), lng: Number(coord.lng) };
                  path = true;
                  coords.push(c);
                });
              }
              if (place && place.point && place.point.coordinates && place.point.coordinates.includes(',')) {
                const point = place.point.coordinates.split(',');
                renderMarkers(map, maps, point, place.name);
              }
            });
            if (path && coords.length > 0) {
              setTimeout(() => {
                const cntr = parseInt(coords.length / 2, 10);
                const newCenter = coords[cntr];
                map.setCenter(newCenter);
                map.setZoom(12);
              }, 100);
            }
            /*
            if (element.document.placemark && element.document.placemark[0] && element.document.placemark[0].point && element.document.placemark[0].point.coordinates) {
              const point = element.document.placemark[0].point.coordinates.split(',');
              renderMarkers(map, maps, point, element.document.placemark[0].name);
            }
            */
          }
        }
      });
    }
    // Construct the polygon.
    const poly = new maps.Polygon({
      paths: coords,
      strokeColor: '#ff0000', // '#383838',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#F6821E', // 'wheat', !path ? '#78DA89' :
      fillOpacity: 0.5,
    });
    poly.setMap(map);
  }
  const kmlmapTemplate = () => (
    <KMLMapContainer props={kmapProps} onRender={renderMap} />
  );
  const kmlMap = (props) => {
    setKMapProps(props);
    setKMapDialog(true);
  };
  function dateUpdated(e) {
    if (e && e.target && e.target.id.length > 0) {
      const pidAry = e.target.id.split('_');
      if (pidAry.length >= 2) {
        const pid = pidAry[1];
        let found = -1;
        for (let i = 0; i < data.jobs.length; i += 1) {
          if (pid === data.jobs[i].Id) {
            found = i;
            break;
          }
        }
        if (found !== -1 && kanbanObj && data.jobs[found]) {
          const fieldname = pidAry[0];
          if (e.value !== data.jobs[found].fieldname) {
            if (confirm(`Update Job  ${data.jobs[found].title} set ${fieldname} to ${e.value}`)) {
              // eslint-disable-next-line prefer-object-spread
              switch (fieldname) {
                case 'date':
                  data.jobs[found].date = e.value;
                  break;
                case 'enddate':
                  data.jobs[found].enddate = e.value;
                  break;
                case 'time':
                  data.jobs[found].time = e.value;
                  break;
                case 'endtime':
                  data.jobs[found].endtime = e.value;
                  break;
                default:
                  return;
              }
              const carddata = {
                Id: data.jobs[found].Id,
                date: data.jobs[found].date,
                enddate: data.jobs[found].enddate,
                description: data.jobs[found].description,
                location: data.jobs[found].location,
                manager: e.value,
                organization: data.jobs[found].organization,
                organizationid: data.jobs[found].organizationid,
                status: data.jobs[found].status,
                time: data.jobs[found].time,
                endtime: data.jobs[found].endtime,
                timestamp: data.jobs[found].timestamp,
                title: data.jobs[found].title,
              };
              const cards = {};
              cards.requestType = 'cardChanged';
              const ary = [];
              ary.push(carddata);
              cards.changedRecords = ary;
              actionComplete(cards);
            }
          }
        }
      }
    }
  }
  function managerUpdated(e) {
    let found = -1;
    for (let i = 0; i < data.jobs.length; i += 1) {
      if (e.target.id === data.jobs[i].Id) {
        found = i;
        break;
      }
    }
    if (found !== -1 && kanbanObj && data.jobs[found]) {
      if (e.value !== data.jobs[found].manager) {
        if (confirm(`Update Job  ${data.jobs[found].title} set Manager to ${e.value}`)) {
          // eslint-disable-next-line prefer-object-spread
          data.jobs[found].manager = e.value;
          const carddata = {
            Id: data.jobs[found].Id,
            date: data.jobs[found].date,
            enddate: data.jobs[found].enddate,
            description: data.jobs[found].description,
            location: data.jobs[found].location,
            manager: e.value,
            organization: data.jobs[found].organization,
            organizationid: data.jobs[found].organizationid,
            status: data.jobs[found].status,
            time: data.jobs[found].time,
            endtime: data.jobs[found].endtime,
            timestamp: data.jobs[found].timestamp,
            title: data.jobs[found].title,
          };
          const cards = {};
          cards.requestType = 'cardChanged';
          const ary = [];
          ary.push(carddata);
          cards.changedRecords = ary;
          actionComplete(cards);
        }
      }
    }
  }
  function cardTemplate(props) {
    const sdid = `date_${props.Id}`;
    const stid = `time_${props.Id}`;
    const edid = `enddate_${props.Id}`;
    const etid = `endtime_${props.Id}`;

    return (
      <div className="card-template">
        <div
          style={{
            border: '2px solid darkgrey',
            zIndex: 1,
            top: 2,
            marginBottom: 'auto',
          }}
          className="e-card-content e-card-separator"
        >
          <table className="card-template-wrap">
            <tbody>
              <tr>
                <td className="CardHeader">Job:</td>
                <td>{props.title || 'unassigned'}</td>
              </tr>
              <tr>
                <td className="CardHeader">Description:</td>
                <td>
                  {props.description || 'unassigned'}
                </td>
              </tr>
              <tr>
                <td className="CardHeader">Manager:</td>
                <td>
                  <DropDownListComponent
                    id={props.Id}
                    dataSource={mgrData}
                    sortOrder="Ascending"
                    defaultValue={props.manager ? props.manager : ''}
                    onChange={managerUpdated}
                    fields={mgrData.fields}
                    placeholder="Select Manager"
                  />
                </td>
              </tr>
              <tr>
                <td className="CardHeader">Date:</td>
                <td>
                <DatePickerComponent
                  id={sdid}
                  name="date"
                  className="e-field e-input"
                  value={props.date}
                  format="MM/dd/yyyy"
                  placeholder="Start Date"
                  onChange={dateUpdated}
                />
                {/*  {props.date ? props.date : 'unassigned'} */}
                </td>
              </tr>
              <tr>
                <td className="CardHeader">Time:</td>
                <td>
                <TimePickerComponent
                  id={stid}
                  name="time"
                  className="e-field e-input"
                  value={props.time}
                  format="h:mm a"
                  placeholder="Start Time"
                  onChange={dateUpdated}
                />
                {/* {props.time ? props.time : 'unassigned'} */}
                </td>
              </tr>
              <tr>
                <td className="CardHeader">End Date:</td>
                <td>
                <DatePickerComponent
                  id={edid}
                  name="enddate"
                  className="e-field e-input"
                  value={props.enddate}
                  format="MM/dd/yyyy"
                  placeholder="End Date"
                  onChange={dateUpdated}
                />
                {/* {props.enddate ? props.enddate : 'unassigned'} */}
                </td>
              </tr>
              <tr>
                <td className="CardHeader">End Time:</td>
                <td>
                <TimePickerComponent
                  id={etid}
                  name="time"
                  className="e-field e-input"
                  value={props.endtime}
                  format="h:mm a"
                  placeholder="End Time"
                  onChange={dateUpdated}
                />
                {/* {props.endtime ? props.endtime : 'unassigned'} */}
                </td>
              </tr>
              <tr>
                <td className="CardHeader">Air Quality:</td>
                <td>
                  {props.aqi && props.aqi.hourlyForecasts && props.aqi.hourlyForecasts[0].indexes ? props.aqi.hourlyForecasts[0].indexes[0].category : 'unknown'}
                </td>
              </tr>
              <tr>
                <td className="CardHeader">Location:</td>
                <td>
                  <DropDownListComponent
                    id={`KML_${props.Id}`}
                    dataSource={kmlData}
                    sortOrder="Descending"
                    value={props.locationName ? props.locationName : props.location.name || ''}
                    fields={kmlData.fields}
                    onChange={locationUpdated}
                    placeholder="Job Location/KML"
                  />
                </td>
              </tr>
              {props.location.name && props.location.name.length > 0 && (
                <tr>
                  <td className="CardHeader">Radius:</td>
                  <td title="Radius in meters from center point">
                    {props.radius ? props.radius : ''}
                  </td>
                </tr>
              )}
              {!kmapDialog && props.location && props.location.Id && props.location.Id !== '1' && (
                <tr>
                <td className="CardHeader">KML:</td>
                <td title="Map">
                  <ButtonComponent iconCss="e-icons e-chart-lines" onClick={() => { kmlMap(props); }}>Map</ButtonComponent>
                </td>
                </tr>
              )}
              {!kmapDialog && (!props.location || !props.location.Id || props.location.Id === '1') && (
                <tr>
                 <td className="CardHeader">KML:</td>
                   <td>
                    <MyDropZone
                      id={props.Id}
                      label="Drag-n-drop KM[L,Z]"
                      onUpload={onDrop}
                    />
                   </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
  function columnTemplate(props) {
    return (
      <div className="header-template-wrap">
        <div className={`header-icon e-icons ${props.keyField}`} />
        <div className="header-text">{props.headerText}</div>
      </div>
    );
  }
  if (loading) {
    return <p>Loading Jobs...</p>;
  }
  return (
    <div className="m-2 md:m-1 mt-2 p-1 md:p-1 bg-white rounded-3xl zackat-divalh">
      <Header category="" title={jobsname} />
      <div id="droparea">
          {crudImport && !isMobile && (
            <div className="control-section accordion-control-section" style={{ width: '45%' }}>
              <div className="control Accordion-sample" style={{ margin: '25px 0' }}>
                <AccordionComponent>
                  <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-8">
                    <div className="e-input-group">
                      <div className="mt-4"> Import </div>
                    </div>
                    <div className="mt-2 e-input-group">
                    <div>
                      Organization: {name}
                    </div>
                      <UploaderComponent
                        id="fileupload"
                        type="file"
                        ref={(uplaod) => { uploadObj = uplaod; }}
                        asyncSettings={jobpath}
                        buttons={buttons}
                        multiple={false}
                        actionComplete={completeUpload}
                        autoUpload={false}
                        uploading={onFileUpload}
                        allowedExtensions=".csv"
                      />
                    </div>
                  </div>
                </AccordionComponent>
              </div>
            </div>
          )}
      </div>
      {/*
      <div
        {...getRootProps()}
        className="zackat-divsquare"
        style={{
          alignContent: 'center',
          height: '60px',
          width: '400px',
          // backgroundImage: 'url("https://monaco.zackat.com/logo.png")',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          color: '#383838',
        }}
      >
        <input id="0" {...getInputProps({ ref: inputRef })} />
        {
          isDragActive
            ? <div style={{ border: 'dashed', borderColor: '#F6821E' }}><p>   Drop the files here ...</p></div>
            : (
              // eslint-disable-next-line jsx-a11y/label-has-associated-control
              <div style={{ border: 'dashed', borderColor: '#F6821E' }}>
                <p>
                Drag-n-drop KML file here, or click to select file
                </p>
              </div>
            )
        }
      </div>
      */}
      {boss && (
        <MyDropZone
          id="Unassigned"
          label="Drag-n-drop KM[L,Z]"
          onUpload={onDrop}
        />
      )}
      {/*
      <label id="showMapLbl" htmlFor="showMap" style={{ padding: '10px 40px 10px 0' }}>
        Show Maps
      </label>
      <SwitchComponent id="showMap" checked={mapDisplay} cssClass="bar-color handle-color" onChange={changeMapDisplay} />
      */}
      {jobs && (
        <KanbanComponent
          cssClass="kanban-overview"
          id="kanban"
          keyField="status"
          dataSource={data.jobs}
          dialogSettings={{ fields, className: 'e-dialog-delete' }}
          // dialogSettings={{ template: dialogCardTemplate }}
          actionComplete={actionComplete}
          allowDragAndDrop
          enablePersistence={false}
          swimlaneSettings={{ keyField: 'organization', allowDragAndDrop: true }}
          ref={kanbanObj}
          cardSettings={{
            headerField: 'Id',
            selectionType: 'Single',
            contentField: 'description',
            template: cardTemplate,
          }}
        >

          <ColumnsDirective>
            <ColumnDirective headerText="Active" keyField="active" template={columnTemplate} showAddButton />
            <ColumnDirective headerText="Completed" keyField="completed" template={columnTemplate} showAddButton />
            <ColumnDirective headerText="Unscheduled" keyField="unscheduled" template={columnTemplate} showAddButton />
            <ColumnDirective headerText="InActive" keyField="inactive" template={columnTemplate} showAddButton />
          </ColumnsDirective>
        </KanbanComponent>
      )}
      {kmapDialog && (
                <DialogComponent
                  header="KML Map Location"
                  content={kmlmapTemplate}
                  width="100%"
                  height="100%"
                  isModal
                  visible
                  closeOnEscape
                  showCloseIcon
                  onClose={() => { setKMapDialog(!kmapDialog); }}
                  close={() => { setKMapDialog(!kmapDialog); }}
                />
      )}
    </div>
  );
};
export default Jobs;
